import React, { useState } from "react";
import { Link } from "react-router-dom";
import StoreControl from "./StoreControl";
import PrinterControl from "./PrinterControl";
import StaffControl from "./staff/StaffControl";
import uRLs from "../../../utils/baseUtils";
import { useAuth } from "../../../context/AuthProvider";
import StockControl from "./StockControl";
import ProductControl from "./ProductControl";
import InvoiceControl from "./InvoiceControl";
import PaymentControl from "./PaymentControl";
import SaleControl from "./SaleControl";
import CustomerControl from "./CustomerControl";
import { usePermission } from "../../../context/PermissionContext";
import GeneralSettings from "./GeneralSettings";
import InvoiceSettings from "./Invoice/InvoiceSettings";
import ReportControl from "./ReportControl";
import PreSaleControl from "./PreSaleControl";
import { BarChartAlt2Icon, CogIcon, CustomersIcon, GroupIcon, MoneyIcon, NegobillIcon, PrinterIcon, ProductIcon, StockIcon, StoreIcon } from "../../../constants/Icons";

const Setting = () => {
  const { isUser } = useAuth();
  const { permission, activeStoreModules } = usePermission();
  const [activeSetting, setActiveSetting] = useState("profile");
  const [isEditMode, setIsEditMode] = useState(false);
  const renderContent = () => {
    switch (activeSetting) {
      case "store":
        return (
          <div className="row">
            <div className="col-lg-12">
              <StoreControl
                setIsEditMode={setIsEditMode}
                isEditMode={isEditMode}
              />
            </div>
            {!isEditMode && (
              <div className="col-lg-12">
                <InvoiceSettings />
              </div>
            )}
          </div>
        );
      case "printer":
        return <PrinterControl />;
      case "invoice":
        return <InvoiceControl />;
      case "stock":
        return <StockControl />;
      case "sale":
        return <SaleControl />;
      case "staff":
        return <StaffControl />;
      case "product":
        return <ProductControl />;
      case "customer":
        return <CustomerControl />;
      case "payment":
        return <PaymentControl />;
      case "productImage":
        return <GeneralSettings />;
      case "invoiceSettings":
        return <InvoiceSettings />;
      case "reportSettings":
        return <ReportControl />;
      case "PreSaleSettings":
        return <PreSaleControl />;
      default:
        return (
          <>
            <div className="row">
              <div className="col-lg-12">
                <StoreControl
                  setIsEditMode={setIsEditMode}
                  isEditMode={isEditMode}
                />
              </div>
              {!isEditMode && (
                <div className="col-lg-12">
                  <InvoiceSettings />
                </div>
              )}
            </div>
          </>
        );
    }
  };

  return (
    <div>
      <div
        className="page-wrapper"
        style={{
          overflow: "auto",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <div className="page-content">
          <div className="row">
            <div className="col-lg-3">
              <div
                style={{
                  height: "calc(100vh - 120px)",
                  overflowY: "auto",
                  position: "sticky",
                  top: "10px",
                }}
              >
                <div className="card">
                  <div className="card-header p-3">
                    <h6 className="card-title mb-0 fw-500 text-primary">
                      Store
                    </h6>
                  </div>

                  <div className="list-group list-group-flush" role="tablist">
                    <Link
                      onClick={() => setActiveSetting("profile")}
                      className={`list-group-item list-group-item-action py-12
                                        ${
                                          activeSetting === "profile"
                                            ? "active"
                                            : ""
                                        }`}
                    >
                      <StoreIcon iClass={"me-2 fs-18"}/>
                      <span className="align-center">Profile</span>
                    </Link>
                    {uRLs.STAFF_ACCESS === "true" &&
                      activeStoreModules("STAFF") && (
                        <Link
                          onClick={() => setActiveSetting("staff")}
                          className={`list-group-item list-group-item-action py-12
                                        ${
                                          activeSetting === "staff"
                                            ? "active"
                                            : ""
                                        }`}
                        >
                          <GroupIcon iClass={"me-2 fs-18"}/>
                          <span className="align-center">Staff Access</span>
                        </Link>
                      )}
                    <Link
                      onClick={() => setActiveSetting("payment")}
                      className={`list-group-item list-group-item-action py-12
                                        ${
                                          activeSetting === "payment"
                                            ? "active"
                                            : ""
                                        }`}
                    >
                      <MoneyIcon iClass={"me-2 fs-18"}/>
                      <span className="align-center">Payment Settings</span>
                    </Link>
                  </div>

                  <div className="card-header p-3">
                    <h6 className="card-title mb-0 fw-500 text-primary">
                      General Settings
                    </h6>
                  </div>

                  <div className="list-group list-group-flush" role="tablist">
                    <Link
                      onClick={() => setActiveSetting("printer")}
                      className={`list-group-item list-group-item-action py-2 
                                        ${
                                          activeSetting === "printer"
                                            ? "active"
                                            : ""
                                        }`}
                    >
                      <PrinterIcon iClass={"me-2 fs-18"}/>
                      <span className="align-center">Printer Control</span>
                    </Link>
                  </div>
                  {/* {isUser?.stype === "MAIN" &&( */}
                  <>
                    <div className="card-header p-3">
                      <h6 className="card-title mb-0 fw-500 text-primary">
                        Account Settings
                      </h6>
                    </div>

                    <div className="list-group list-group-flush" role="tablist">
                      <Link
                        onClick={() => setActiveSetting("productImage")}
                        className={`list-group-item list-group-item-action py-2 
                                        ${
                                          activeSetting === "productImage"
                                            ? "active"
                                            : ""
                                        }`}
                      >
                        <CogIcon iClass={"me-2 fs-18"}/>
                        <span className="align-center">General Settings</span>
                      </Link>
                      <Link
                        onClick={() => setActiveSetting("customer")}
                        className={`list-group-item list-group-item-action py-2 
                                            ${
                                              activeSetting === "customer"
                                                ? "active"
                                                : ""
                                            }`}
                      >
                        <CustomersIcon iClass={"me-2 fs-16"}/>
                        <span className="align-center">Customer</span>
                      </Link>
                      <Link
                        onClick={() => setActiveSetting("product")}
                        className={`list-group-item list-group-item-action py-2 
                                            ${
                                              activeSetting === "product"
                                                ? "active"
                                                : ""
                                            }`}
                      >
                        <ProductIcon iClass={"me-2 fs-6"}/>
                        <span className="align-center">Product</span>
                      </Link>
                      <Link
                        onClick={() => setActiveSetting("sale")}
                        className={`list-group-item list-group-item-action py-2 
                                            ${
                                              activeSetting === "sale"
                                                ? "active"
                                                : ""
                                            }`}
                      >
                        <NegobillIcon iClass={"me-2 fs-18"}/>
                        <span className="align-center">Sales & Pre Sale</span>
                      </Link>
                      <Link
                        onClick={() => setActiveSetting("stock")}
                        className={`list-group-item list-group-item-action py-2 
                                            ${
                                              activeSetting === "stock"
                                                ? "active"
                                                : ""
                                            }`}
                      >
                        <StockIcon iClass={"me-2 fs-18"}/>
                        <span className="align-center">Stock</span>
                      </Link>
                      {/* {uRLs.INVOICE_SETTINGS === "true" && (
                      <Link
                        onClick={() => setActiveSetting("invoiceSettings")}
                        className={`list-group-item list-group-item-action py-2 
                                            ${
                                              activeSetting ===
                                              "invoiceSettings"
                                                ? "active"
                                                : ""
                                            }`}
                      >
                        <i className="bx bxs-file-pdf me-2 fs-18"></i>
                        <span className="align-center">Invoice</span>
                      </Link>
                    )} */}
                      <Link
                        onClick={() => setActiveSetting("reportSettings")}
                        className={`list-group-item list-group-item-action py-2 
                                            ${
                                              activeSetting === "reportSettings"
                                                ? "active"
                                                : ""
                                            }`}
                      >
                        <BarChartAlt2Icon iClass={"me-2 fs-18"}/>
                        
                        <span className="align-center">Report</span>
                      </Link>
                      {/* <Link
                        onClick={() => setActiveSetting("PreSaleSettings")}
                        className={`list-group-item list-group-item-action py-2 
                                            ${
                                              activeSetting ===
                                              "PreSaleSettings"
                                                ? "active"
                                                : ""
                                            }`}
                      >
                        <i className="bi bi-file-earmark-text me-2 fs-18"></i>
                        <span className="align-center">Pre Sale</span>
                      </Link> */}
                    </div>
                  </>
                  {/* )} */}
                </div>
              </div>
            </div>
            <div className="col-lg-9">
              <div
                style={{
                  height: "calc(100vh - 120px)",
                  overflowY: "auto",
                  overflowX: "hidden",
                  paddingRight: "10px",
                }}
              >
                {renderContent()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Setting;
